import { render } from "./HomeLoader.vue?vue&type=template&id=7c8cc4b0"
import script from "./HomeLoader.vue?vue&type=script&lang=js"
export * from "./HomeLoader.vue?vue&type=script&lang=js"

import "./HomeLoader.vue?vue&type=style&index=0&id=7c8cc4b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__